module.exports = __webpack_public_path__ + "img/1f.44813699.png";